
////////////////////
// Template
////////////////////
const template = /*html*/ `

    <div class="c-cart_shipping" :style="{ '--progress-shipping': progress + '%' }">
        <div class="c-cart_shipping_progress"></div>
        <div class="c-cart_shipping_content">
            <span class="c-cart_shipping_content_hint" v-if="currentRemaining > 0">
                <slot name="free-shipping-remaining-a"></slot> <strong>{{ currentRemaining | price }}</strong> <slot name="free-shipping-remaining-b"></slot>
            </span>
            <span class="c-cart_shipping_content_hint" v-else>
                <slot name="free-shipping"></slot>
            </span>
            <span class="c-cart_shipping_content_hint -small">
                <slot name="free-shipping-condition"></slot>
            </span>
        </div>
    </div>

`;


////////////////////
// Scripts
////////////////////
export default function VueCart(moduleInstance) {

    Vue.component("cart-shipping", {

        template,

        props: {
            threshold: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                moduleInstance: moduleInstance,
                cartSubtotal: 0,
                progress: 0
            };
        },

        computed: {
            currentRemaining() {
                return (this.threshold - this.cartSubtotal) / 100 || 0;
            }
        },

        methods: {
            setShippingProgress(cart) {
                const subtotal = parseInt(cart?.total_price) || null;
                this.cartSubtotal = subtotal;

                if(!subtotal) {
                    this.progress = 0;
                    return;
                };

                const progress = (subtotal / this.threshold) * 100;

                this.progress = progress;
            }
        },

        filters: {
            price(value) {
                if (typeof value != "number") return value;

                const formattedAmount = new Intl.NumberFormat(window?.Shopify?.locale, {
                    style: 'currency',
                    currencyDisplay: 'narrowSymbol',
                    currency: window?.Shopify?.currency?.active
                }).format(value)

                return formattedAmount;
            },
        }
    });
}
